import React from 'react'
import SelectedCheckbox from "../../../user-manager/components/datas/SelectedCheckbox"

function RolesFunctionItem(props) {
    const {item, arrSelected, onSelected} = props

    return (
        <tr className="RowItem">
            <td className="selectItem">
                <SelectedCheckbox
                    id={item.objectId}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                />
            </td>
            <td className="itemCol">{item.objectName || ''}</td>
            <td className="itemCol">{item.description || ''}</td>
        </tr>
    )
}

export default RolesFunctionItem
